import postAPI from './postAPI.js'

export default async function postRetryActionDelivery(deliveryId) {
    const data = await postAPI('admin/taskflows/actions/deliveries/retry', { id: deliveryId });
    return data;
}
